module.exports = __webpack_public_path__ + "img/logo_ese_netsecurity_tras.fb3e568d.png";